import React from 'react'
import PropTypes from 'prop-types'
import { getClassNames, filterInvalidProps } from './utils'
import {
  AlignSelfPropTypes,
  ColFlexPropTypes,
  ColPullPropTypes,
  ColPushPropTypes,
  ColOffsetPropTypes,
  ColPropTypes
} from './types'

const classMap = {
  xs: 'col',
  sm: 'col-sm',
  md: 'col-md',
  lg: 'col-lg',
  xl: 'col-xl',
  xsOffset: 'offset',
  smOffset: 'offset-sm',
  mdOffset: 'offset-md',
  lgOffset: 'offset-lg',
  xlOffset: 'offset-xl',
  xsPush: 'push',
  smPush: 'push-sm',
  mdPush: 'push-md',
  lgPush: 'push-lg',
  xlPush: 'push-xl',
  xsPull: 'pull',
  smPull: 'pull-sm',
  mdPull: 'pull-md',
  lgPull: 'pull-lg',
  xlPull: 'pull-xl',
  xsFlex: 'flex',
  smFlex: 'flex-sm',
  mdFlex: 'flex-md',
  lgFlex: 'flex-lg',
  xlFlex: 'flex-xl',
  xsAlignSelf: 'align-self',
  smAlignSelf: 'align-self-sm',
  mdAlignSelf: 'align-self-md',
  lgAlignSelf: 'align-self-lg',
  xlAlignSelf: 'align-self-xl'
}

const Col = props => {
  const { children, ...otherProps } = filterInvalidProps(props, classMap)
  const extraClass = ['col']
  const classNames = getClassNames(props, classMap, extraClass)

  return (
    <div {...otherProps} className={classNames}>
      {children}
    </div>
  )
}

Col.propTypes = {
  xs: ColPropTypes,
  sm: ColPropTypes,
  md: ColPropTypes,
  lg: ColPropTypes,
  xl: ColPropTypes,
  xsOffset: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  smOffset: ColOffsetPropTypes,
  mdOffset: ColOffsetPropTypes,
  lgOffset: ColOffsetPropTypes,
  xlOffset: ColOffsetPropTypes,
  xsPush: ColPushPropTypes,
  smPush: ColPushPropTypes,
  mdPush: ColPushPropTypes,
  lgPush: ColPushPropTypes,
  xlPush: ColPushPropTypes,
  xsPull: ColPullPropTypes,
  smPull: ColPullPropTypes,
  mdPull: ColPullPropTypes,
  lgPull: ColPullPropTypes,
  xlPull: ColPullPropTypes,
  xsFlex: ColFlexPropTypes,
  smFlex: ColFlexPropTypes,
  mdFlex: ColFlexPropTypes,
  lgFlex: ColFlexPropTypes,
  xlFlex: ColFlexPropTypes,
  xsAlignSelf: AlignSelfPropTypes,
  smAlignSelf: AlignSelfPropTypes,
  mdAlignSelf: AlignSelfPropTypes,
  lgAlignSelf: AlignSelfPropTypes,
  xlAlignSelf: AlignSelfPropTypes,
  children: PropTypes.node
}

export { Col }



// WEBPACK FOOTER //
// ./src/components/Grid/Col.js